module.exports = __webpack_public_path__ + "img/L_320_325.4b7bef85.png";